import React from "react";
import PropTypes from "prop-types";
import { TextArea } from "semantic-ui-react";
import _ from "lodash";

const propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  label: PropTypes.string
};

const defaultProps = {
  value: "",
  label: "Descripción",
  placeholder: "Descripción",
  onChange: () => {}
};

class CustomTextArea extends React.Component {
  constructor(props) {
    super(props);
    this.changed = _.debounce(this.props.onChange, 500);
    this.state = {
      value: this.props.value || ""
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ value: nextProps.value });
  }

  changed({ value, name }) {
    this.props.onChange({ value, name });
  }

  handleChange = (e, { value, name }) => {
    this.setState({ value });
    this.changed({ value, name });
  };

  render() {
    return (
      <TextArea
        {...this.props}
        value={this.state.value || ""}
        onChange={this.handleChange}
      />
    );
  }
}

CustomTextArea.defaultProps = defaultProps;
CustomTextArea.propTypes = propTypes;

export default CustomTextArea;



// WEBPACK FOOTER //
// ./src/pages/shared/CustomTextArea.jsx